<template>

    <div class="home">
        <HeadBar />
        <div style="background: #f1f2f6;">
            <div class="container" style="max-width: 912px;">
                <div class="row">
                    <div class="gradient-text" style="color: black; margin: 40px 0px 16px 0px;">
                        <span class="gradient">How Does</span> Contractly <span class="gradient2">Work To</span> Protect You
                    </div>  
                     
                    <div class="d-flex justify-content-center toggle-btn-group mb-4" style="display: none !important;">
                        <button
                            class="btn me-3 btn-success"
                           
                            @click="selectedTab = 'client'"
                        >
                            Client Contracts
                        </button>
                        <button
                            class="btn me-3 "  style="color: white; background-color: black;"                       
                            @click="selectedTab = 'sub'"
                        >
                            Sub Contractor Contracts
                        </button>
                        </div>

                        <div v-for="(item, index) in tabs[selectedTab]" :key="index" class="card shadow-sm mb-3" style="padding: 0px;">
                            <div class="card-header d-flex justify-content-between align-items-center bg-white" style="padding: 0 16px 0 0; ">
                                <div class="d-flex align-items-center" style="flex: 1;">
                                   <img :src="item.icon" alt="icon" class="icon-img me-2" />
                                    <div class="item-title" >{{ item.title }}</div>
                                </div>
                                <i class="bi bi-chevron-down text-muted" style="font-size: 12px; font-weight: bold !important;"></i>
                            </div>
                            <div class="card-body bg-light-yellow" v-html="item.content">
                              
                            </div>
                        </div>

                </div>
            </div>
        </div>
 

        <Foot />
        <SignIn ref="signIn"></SignIn>
        <SignUp ref="signUp" :partyId="partyId" @showTerms="onShowTerms"></SignUp>
        <CommonInfo ref="terms"></CommonInfo>
    </div>
   
</template>

<script>
    
    import HeadBar from '../components/HeadBar';
    import Foot from '../components/Foot';
    import SignIn from '../components/SignIn';
    import SignUp from '../components/SignUp';
    import CommonInfo from '../components/CommonInfo';
    import { isNullOrEmpty } from '../composables/utils';
    import http from '../composables/http';



    export default {
        name: 'home-test',
        components: {
            HeadBar, Foot, SignIn, SignUp, CommonInfo
        },
        data() {
            return {
                settings: null,
                subscriptionPlans:[],
                partyId: null,
                selectedTab : 'client',
                tabs: {
                    client: [
                    {
                    icon: new URL('@/assets/images/howwework/1.png', import.meta.url).href,
                    title: 'Your Client is late on payment or does not pay the full amount',
                    content:
                        'A payment terms section that defines exactly when the Client is to pay you! You choose whether payment is by Date or by completed Milestone. <br />We have also included Client default/arrears terms that define clear repercussions and penalties & interest.'
                    },
                    {
                    icon: new URL('@/assets/images/howwework/2.png', import.meta.url).href,
                    title:
                        'Your Client is always asking you to do extra things thinking it is included in your services.',
                    content:
                        'We have developed clear & concise terms that define what you are and are not responsible for. '
                    },
                    {
                    icon: new URL('@/assets/images/howwework/3.png', import.meta.url).href,
                    title: 'Your Client is still contacting you about warranty issues 3 years later!',
                    content:
                        'A defined limited Guarantee and Warranty clause that speaks to equipment, materials, and workmanship. You can even amend to suit your needs!'
                    },

                    {
                    icon: new URL('@/assets/images/howwework/4.png', import.meta.url).href,
                    title: 'Have you ever had a Client cancel on you last minute?',
                    content:
                        'We have built in clauses that define when your Client may cancel with exact language detailing penalties.'
                    },

                    {
                    icon: new URL('@/assets/images/howwework/5.png', import.meta.url).href,
                    title: 'Has a Client ever tried to cancel on you after you commenced the project?',
                    content:
                        'We have included language that details when a Client may cancel if your project has commenced. We have also developed clauses that speak to penalties and forfeiure of deposits (if any).'
                    },

                     {
                    icon: new URL('@/assets/images/howwework/6.png', import.meta.url).href,
                    title: 'Has a Client ever blamed you for taking too long when it wasn\'t your fault?',
                    content:
                        'We have included clauses that protect you in the event you are delayed from things that are out of your control. We have also built in language that allows you extend the completion date for any reason and without penalty.'
                    },

                    {
                    icon: new URL('@/assets/images/howwework/7.png', import.meta.url).href,
                    title: 'Has a Client ever tried to deal directly (poach) your Employees or Sub-Contractors?',
                    content:
                        'We have written a Non-Solicitation clause to protect you and provide financial recourse in the event your Client deals directly with your employees or sub-contractors.'
                    },

                    {
                    icon: new URL('@/assets/images/howwework/8.png', import.meta.url).href,
                    title: 'Have you ever started a job only to find that the prices for materials have substantially increased?',
                    content:
                        'We included language that provides you the flexibility to amend any previous price quote should materials and labor rise due to unforeseen circumstances.'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/9.png', import.meta.url).href,
                    title: 'Have you ever had a Client say to you that you made different promises to them previously; in person, on the phone, email or text?',
                    content:
                        'We built an "Entire Agreement" clause that clearly spells out that whatever is written in the contract shall supercede any other conversations through any other means.'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/10.png', import.meta.url).href,
                    title: 'Have you ever had the need to commence your project later (or earlier) than what you promised your Client?',
                    content:
                        'We have designed clauses that allow you extreme flexibility in the event you need to commence a project earlier or later than promised with no penalties to you!'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/11.png', import.meta.url).href,
                    title: 'Are there ever any occasions you are not able to complete the project on time?',
                    content:
                        'If, for whatever reason you find yourself not able to complete your services by the date you promised your Client, we have written language that allows you flexible scenarios in your favour which you may choose to exercise.'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/12.png', import.meta.url).href,
                    title: 'Are you concerned that a Client will leave you a less than stellar review?',
                    content:
                        'We have incorporated a Confidentiality clause that spells out what your Cient may or may not divulge once your project is complete.'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/13.png', import.meta.url).href,
                    title: 'Would you like to define or limit your liability?',
                    content:
                        'We have a well written clause that protects you in the event your Client seeks out any grievance against you by limiting your liability to them.'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/14.png', import.meta.url).href,
                    title: 'Do you want a clause that allows you to take pictures and videos of your work?',
                    content:
                        'Do you ever need to take pictures or video of the project for your own marketing purposes. Maybe your website or social media? We have written a clause that allows for that!'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/15.png', import.meta.url).href,
                    title: 'Have you ever needed to insist that the Client is offsite while you are providing services?',
                    content:
                        'Our default template provides you the final say on whether or not your Client may be present while you are working. You may also amend to suit your needs!'
                    },
                    
                    {
                    icon: new URL('@/assets/images/howwework/16.png', import.meta.url).href,
                    title: 'Do you need a clause that holds multiple signatory s jointly and severally liable?',
                    content:
                        'If there are multiple homeowners who wil be signing your aervice agreement, we developed a clause wherby each person who signs is responsible for all the obligations listed on the agreement!'
                    },
                     
                ],
                sub: [
                    {
                    icon: new URL('@/assets/images/howwework/1.png', import.meta.url).href,
                    title: 'Your Sub Contractor misses deadlines or disappears',
                    content:
                        'Our contracts define deliverables, timelines, and penalties if the Sub Contractor fails to meet them.'
                    },
                    {
                    icon: new URL('@/assets/images/howwework/1.png', import.meta.url).href,
                    title: 'Sub Contractor disputes payment',
                    content:
                        'Clearly outlined payment schedule and milestone-based payouts help resolve payment disputes quickly.'
                    }
                ]
                }

            }
        },
        mounted() {
            const key = this.$route.query.key;
            if (key!=null) {
                http.request("get", "/api/common/readkey", { key }).then(res => {
                    console.log("key", res);
                    if (res?.Type == 200) {
                        if (res.Content == "Your account has been activated successfully" && !isNullOrEmpty(res.Data?.PhoneNumber)) {
                            this.$router.push(`/login?s=preset&account=${res.Data.PhoneNumber}`)
                        }
                    }

                });
            } 

            http.request("get", `/api/site/subscriptionplans`).then(res => {
                    if (res?.Type == 200) {
                        this.subscriptionPlans = res.Data;
                    }

                });

            if (this.$route.query.ref != null
                && this.$route.query.key != null
                && this.$route.query.email != null) {
                this.$refs.signUp.show();
            }
            else {
                if (this.$route.query.usr != null) {
                    this.$refs.signIn.show();
                }
            }
        },
        methods: {
            signIn() {               
                //this.$router.push('/SignIn');
                this.$refs.signIn.show();
            },
            signUp() {
                //this.$router.push('/SignUp');
                this.$refs.signUp.show();
            },
            onShowTerms() {
                this.$core.GetUserTerms().then((x) => {
                    if (x.Message != '') {
                        alert(x.Message);
                    } else {
                        this.$refs.terms.show("Terms of Services",x.Object);
                    }
                });               
            }
        }
    };
</script>
<style>
    @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans&family=Roboto&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css');
</style>
 
<style scoped>

    .gif-container {
         
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center; /* Center horizontally */
        align-items: flex-end; /* Align to the bottom */
    }
    .price-bg {
        margin: 8px auto;
        max-width: 300px;
        min-height: 400px;
        border-radius: 8px;
        padding: 8px;
        height: calc(100% - 16px);
    }
    .background1{
        background-image: url('../assets/img/Price1background.png');
        background-size: cover;
    }
    .background2{
        background-image: url('../assets/img/Price2background.png');
        background-size: cover;
    }
    .background3{
        background-image: url('../assets/img/Price3background.png');
        background-size: cover;
    }
    .price{
        font-size: clamp(11px, 1.3vw, 15px);
        color: black;
        font-weight: bold;
        padding: 0 16px;
        margin-bottom: 16px;
        height: 20px;
    }
    .price-text{
        font-size: clamp(18px, 1.4vw, 28px);
        color: black;
        font-weight: bold;
        padding: 16px;
    }
    .get-started{
        border: 2px solid black;
        font-size: clamp(14px, 1.4vw, 18px);
        border-radius: 8px;
        cursor: pointer;
        width: 90%;
        font-weight: bold;
        margin: 0 auto;
        padding: 4px 0px;
        text-align: center;
    }
        .get-started:hover {
            border-color: #473d82; /* �߿���ɫ��Ϊ�������ɫ */
            background-color: rgba(71, 61, 130, 0.05); /* ��΢����ɫ */
            transition: border-color 0.3s, background-color 0.3s;
        }
    .price-info{
        font-size: 14px;
        padding: 8px 15px;
    }
    .font-ajust { font-size: clamp(12px, 2vw, 16px); color: black; }
    .subtitle{
        font-size: clamp(18px, 2vw, 24px);
        color: black;
        font-weight: bold;
        text-align: center;
    }
    .gradient-text {
        font-size: clamp(20px, 2vw, 36px);
        font-weight: bold;
        color: #222;
        text-align: center;
    }

    .gradient-text .gradient {
        background: linear-gradient(90deg, #198655, #3e6e98);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .gradient-text .gradient2 {
        background: linear-gradient(90deg, #6356de, #235566);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .gradient-text .gradient3 {
        background: linear-gradient(90deg, #5e59d5, #406d9d);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }


    .gradient-text .gradient4 {
        background: linear-gradient(90deg, #0c553c, #065530);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .gradient-text .gradient5 {
        background: linear-gradient(90deg, #0e6a3f, #357489);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .icon{margin: 0px;}
    .button-box{
        /*background:linear-gradient(90deg, #7fcfaa, #51ab8a);*/
        font-size: clamp(14px, 1.5vw, 18px);
        font-weight: bold;
        /* Dynamic font size */
        width: 90%;
        margin: 16px auto;
        color: white;
        padding: 20px;
        display: flex;
        gap: 12px;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        align-content: center;
        justify-content: center;
        min-height: 100px;
        overflow: hidden;
    }
    .block-container {
        display: flex;
        flex-wrap: wrap; /* Allow wrapping for desktop */
        gap: 50px; /* Space between cards */
        justify-content: center; /* Center items */
        flex-wrap: wrap;       
        max-width: 900px;
        margin: 24px auto;
       
    }

    /* Button Style */
    .gradient-btn {
            flex: 1 1 calc(33.33% - 40px); /* 3 items per row with gap adjustment */
            max-width: 230px; /* Ensure max 3 items per row */
            min-width: 230px; /* Minimum width for readability */
            background-color: #e6f0fa;
            border-radius: 10px;
            padding: 130px 20px 20px 20px;
            text-align: left;
            position: relative;
            background-size: cover;
    }


    /* Specific Background Images */
    .btn-1 {
        background-image: url('../assets/img/BLOCK1.png');
    }

    /* Replace with actual image URL */
    .btn-2 {
        background-image: url('../assets/img/BLOCK2.png');
    }

    .btn-3 {
        background-image: url('../assets/img/BLOCK3.png');
    }

    .btn-4 {
        background-image: url('../assets/img/BLOCK4.png');
    }
    .btn-5 {
        background-image: url('../assets/img/BLOCK5.png');
    }
    .btn-6 {
        background-image: url('../assets/img/BLOCK6.png');
    }

    /* Hover Effect */
    .gradient-btn:hover {
        opacity: 0.9;
    }

    .clear-concise {
        background-image: url('../assets/img/CLEARBG.png');
        background-size: cover;
        background-position: center;
        max-width: 912px;
        justify-self: center;
        align-items: center;
        margin: auto;
    }
    .sub-bg {
        background-image: url('../assets/img/SUBCONTRACTORAGREEMENTBG.png');
        background-size: cover;
        background-position: center;
        max-width: 912px;
        justify-self: center;
        align-items: center;
        margin: auto;
    }

    .title-text{
        font-size: 40px; color: #132338; max-width: 400px; text-align: left; 
    }



    .toggle-btn-group .btn {
        border-radius: 12px;
        padding: 10px 20px;
        font-weight: bold;
        width: 240px;
        line-height: 24px;
        height: fit-content;
        }
 

        .card-body.bg-light-yellow {
            background-color: #fff8e1;
            border-top: 1px solid #e0e0e0;
            font-size: 0.95rem;
            line-height: 1.6;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
        }

        .item-title {
            font-weight: bold;
            color: #198754;
        }

        .icon-img {
            width: 32px;
            height: 32px;
            object-fit: contain;
            }

    /* Responsive */
    @media (max-width: 768px) {
         
        .title-text{
            font-size: 32px;
            max-width : unset;
            text-align: center;
        }

        .block-container {
                flex-wrap: nowrap; /* Prevent wrapping on mobile */
                overflow-x: auto; /* Enable horizontal scrolling */
                justify-content: flex-start; /* Align items to the left */
                padding-bottom: 10px; /* Space for scrollbar */
                gap: 20px;
            }

            .gradient-btn {
                flex: 0 0 80%; /* Each card takes 80% of the viewport width */   
                width: 220px; /* Minimum width for readability */
            }

            
    }
</style>

